"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const FEATURE_PATH = `/settings`;
const FETCH_INTERVAL_MS = 1000 * 60 * 5;
class ApiService {
    constructor() {
        this.featureStatus = {};
        this.lastUpdatedAt = 0;
        this.updateIntervalMS = FETCH_INTERVAL_MS;
    }
    getFeatureStatus() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isUpdateNeeded()) {
                return this.featureStatus;
            }
            const response = yield this.fetch(FEATURE_PATH);
            this.featureStatus = (_a = response.features) !== null && _a !== void 0 ? _a : {};
            this.lastUpdatedAt = Date.now();
            return this.featureStatus;
        });
    }
    init(options) {
        var _a;
        this.baseURL = options === null || options === void 0 ? void 0 : options.baseURL;
        this.lastUpdatedAt = 0;
        this.updateIntervalMS = (_a = options === null || options === void 0 ? void 0 : options.updateIntervalRateMS) !== null && _a !== void 0 ? _a : FETCH_INTERVAL_MS;
    }
    fetch(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.request({
                baseURL: this.baseURL,
                url,
            });
            return response.data;
        });
    }
    isUpdateNeeded() {
        return (this.lastUpdatedAt + this.updateIntervalMS) < Date.now();
    }
}
exports.default = ApiService;
//# sourceMappingURL=api.service.js.map